module.exports = __webpack_public_path__ + "static/media/agenda-meeting.991f32bc.svg";